// extracted by mini-css-extract-plugin
export var wrapperStyle = "toc_nav_mobile-module--wrapperStyle--J6UQ4";